/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const ALL_DISCOUNT = gql`
query GetAllDiscounts($filter: DiscountFilterInput) {
    getAllDiscounts(filter: $filter) {
      content {
        _id
        name
        discountType
        presentation {
          _id
          name
        }
        section {
          id
          name
        }
        sectionOptType {
          id
          name
        }
      }
    }
  }
`;